import React, { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import NewCropRequestPrice from './components/NewCropRequestPrice';
import EditCropRequestPrice from './components/EditCropRequestPrice';
import CropRequestPricesList from './components/CropRequestPricesList';

const CropRequestPrices = () => {
  const [editCropRequestPrice, setEditCropRequestPrice] = useState({ collection: null, resolution: null });
  const [listRequiresReload, setListRequiresReload] = useState(true);

  return (
    <Container>
      <Row>
        <Col md={12}>
          <h3 className="page-title">Crop Requests Price Management</h3>
          <h3 className="page-subhead subhead">Manage price scheme for crop requests</h3>
        </Col>
      </Row>
      <Row>
        <Col md={8}>
          <CropRequestPricesList setEditCropRequestPrice={setEditCropRequestPrice} setListRequiresReload={setListRequiresReload} listRequiresReload={listRequiresReload}/>
        </Col>
        <Col md={4}>
          {!editCropRequestPrice.collection && <NewCropRequestPrice setListRequiresReload={setListRequiresReload}/>}
          {editCropRequestPrice.collection && <EditCropRequestPrice setListRequiresReload={setListRequiresReload} cropRequestPrice={editCropRequestPrice} setEditCropRequestPrice={setEditCropRequestPrice} />}
        </Col>
      </Row>
    </Container>
  );
};

export default CropRequestPrices;